import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgChevronDown = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M5.193 6.21a.62.62 0 0 1 .931 0L8 8.263 9.876 6.21a.62.62 0 0 1 .931 0 .77.77 0 0 1 0 1.018L8.466 9.79a.62.62 0 0 1-.932 0L5.193 7.23a.77.77 0 0 1 0-1.018"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
